import { Component, Input } from '@angular/core';
import { Constants } from 'src/app/_constants/constants';

/**
 * Flags the area/org name on a row whose value has been withheld for disclosure
 * control, rather than leaving the blank cells unexplained. Shown wherever a table
 * lists one row per area - the "why is this one blank" the reader needs sits next
 * to the name, not buried in a column most tables don't even show.
 */
@Component({
  selector: 'app-suppressed-value-flag',
  templateUrl: './suppressed-value-flag.component.html',
  styleUrls: ['./suppressed-value-flag.component.scss'],
  standalone: false
})
export class SuppressedValueFlagComponent {
  /** The row's ValueNote, exactly as returned by the API. */
  @Input() public valueNote: string;

  public get isSuppressed(): boolean {
    return Constants.suppressedValueNotes.includes((this.valueNote || '').trim());
  }
}
